import { useAuthStore, isInstructor } from './store/auth';
import LoginPage from './views/LoginPage';
import Layout from './components/Layout';

export default function App() {
  const user = useAuthStore((s) => s.user);
  const token = useAuthStore((s) => s.token);

  if (!token || !isInstructor(user)) {
    return <LoginPage />;
  }
  return <Layout />;
}
